"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtrasBannerBreakdownCover = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var ExtrasBannerBreakdownCover = /** @class */ (function (_super) {
    __extends(ExtrasBannerBreakdownCover, _super);
    function ExtrasBannerBreakdownCover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtrasBannerBreakdownCover.prototype.render = function () {
        var _this = this;
        var interaction = this.props.interaction;
        var optionalExtras = interaction.optionalExtras;
        var isMonthly = interaction.factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
        var amount = isMonthly ? optionalExtras.breakdownCoverLocalMonthlyCost : optionalExtras.breakdownCoverLocalCost;
        var price = services_1.CommonHelpers.getAmountWithDecimalDigits(amount);
        return ((0, jsx_runtime_1.jsxs)("div", { className: "banner carousel-banner banner-content", children: [(0, jsx_runtime_1.jsx)("img", { className: "banner-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/tow-truck.svg"), alt: "Breakdown cover" }), (0, jsx_runtime_1.jsxs)("div", { className: "banner-text", children: [(0, jsx_runtime_1.jsx)("div", { className: "banner-title mb-3", children: "Breakdown cover" }), "Choose from our 3 levels of breakdown cover: Local, National or European.", (0, jsx_runtime_1.jsxs)("p", { className: "mt-3", children: [(0, jsx_runtime_1.jsx)("img", { className: "carousel-banner-arrow", src: "/".concat(services_1.resourcesHelper.THEME, "/img/arrow-right.svg"), alt: "Arrow icon" }), (0, jsx_runtime_1.jsxs)("button", { className: "btn-text cursor-pointer", onClick: function () { return _this.props.editCoverLevelNavigate(); }, children: ["Add Breakdown from ", price, " /", isMonthly ? "month" : "year"] })] })] })] }));
    };
    return ExtrasBannerBreakdownCover;
}(React.Component));
exports.ExtrasBannerBreakdownCover = ExtrasBannerBreakdownCover;
//# sourceMappingURL=ExrasBannerBreakdownCover.js.map